import { Component, computed, Inject, Optional, inject, model, OnInit, signal } from '@angular/core';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ChipComponent } from "app/modules/global-components/chip/chip.component";
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { FormsModule } from '@angular/forms';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { RegistrosService } from '../registros.service';
import { Tipologia } from 'app/modules/models/tipologia.model';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { CarreraModel } from 'app/modules/models/carreras.model';
import { environment } from 'enviroments/environment';
import { ControlAccesoDirective } from 'app/shared/directives/control-acceso.directive';
import { ApiService } from 'app/core/services/api.service';
import { UtilsService } from 'app/modules/utils.service';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'registros-form-componenent',
    templateUrl: 'agregar-editar-registro.html',
    standalone: true,
    imports: [
        ChipComponent,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatChipsModule,
        CommonModule,
        FormsModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatInputModule,

        ControlAccesoDirective
    ],
})

export class AgregarEditarRegistroComponent implements OnInit {

    readonly carreaModel = new CarreraModel();

    readonly words = signal([]);
    readonly WordsTuple = signal <Tipologia[]>([]);

    readonly currentWord = model('');
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    allWords = [];
    allWordsTipology: Tipologia[]= [];
    ciclos: Tipologia[] = [];
    modalidad: Tipologia[] = [];
    tipoProfesional: Tipologia[] = [];
    areasCarrera: Tipologia[] = [];
    filteredAreasCarrera: Tipologia[] = [];
    subareasCarrera: Tipologia[] = [];
    filteredSubareasCarrera: Tipologia[] = [];
    areaSearchTerm = '';
    subareaSearchTerm = '';
    carreras: Tipologia[] = [];
    filteredCarreras: Tipologia[] = [];
    carreraSearchTerm = '';
    orientacionesCarrera: Tipologia[] = [];
    filteredOrientacionesCarrera: Tipologia[] = [];
    orientacionSearchTerm = '';
    orientacionesOcupacionales: Tipologia[] = [];
    filteredOrientacionesOcupacionales: Tipologia[] = [];
    orientacionOcupacionalSearchTerm = '';
    selectedArea: Tipologia | null = null;
    selectedSubarea: Tipologia | null = null;
    selectedCarrera: Tipologia | null = null;
    selectedOrientacion: Tipologia | null = null;
    selectedOrientacionOcupacional: Tipologia | null = null;
    private permitirActualizacionCodigo = false;
    private tipologiasCargadas = { area: false, orientacionOcupacional: false, subarea: false };
    private esNuevoRegistro = false;

    // Label para el chip de ciclo
    get cicloLabel(): string {
        return this.carreaModel?.ciclo?.descripcion || 'Seleccionar ciclo';
    }

    readonly filteredWords = computed(() => {
        const currentWord = this.currentWord().toLowerCase();
        return currentWord
        ? this.allWords.filter(word => word.toLowerCase().includes(currentWord))
        : this.allWords.slice();
    });

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CarreraModel | null,
        @Optional() public _dialogRef: MatDialogRef<AgregarEditarRegistroComponent> | null,
        private _registrosService:RegistrosService,
    private _apiService: ApiService,

    )
    {
        const esNuevo = !data || (data.carreraId ?? 0) === 0;
        this.esNuevoRegistro = esNuevo;
        this.permitirActualizacionCodigo = esNuevo; // Habilita cálculo de código en altas

        if (data) {
            this.carreaModel = this.clonarCarrera(data);
        }
        if (this.esNuevoRegistro) {
            this.carreaModel.subarea = '';
            this.carreaModel.orientacion = '';
            this.carreaModel.orientacionOcupacional = '';
            this.carreaModel.modalidad = '';
            this.carreaModel.profesional = '';
            this.carreaModel.carrera = '';
        }

        this._registrosService.getPalabrasClave()
            .then(( (data: Tipologia[]) => {
                this.allWords = data.map(d => d.descripcion)
                this.allWordsTipology = data
                this.filteredWords
            }))

        // Cargar tipología de ciclos para selección
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_CICLO)
            .then((response: Tipologia) => {
                this.ciclos = response.tipologias || [];
                if (!this.carreaModel.ciclo || !this.carreaModel.ciclo.tipologiaId) {
                    this.carreaModel.ciclo = this.ciclos[0];
                } else {
                    const cicloExistente = this.ciclos.find(
                        c => c.tipologiaId === this.carreaModel.ciclo.tipologiaId
                    );
                    if (cicloExistente) {
                        this.carreaModel.ciclo = cicloExistente;
                    }
                }
                this.cargarTipologiasCarrera();
            });

        this.WordsFromModel();
    }
    readonly announcer = inject(LiveAnnouncer);

    ngOnInit() {
        this.getModalidad();
        this.getTipoProfesional();
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our fruit
        if (value) {
        this.words.update(words => [...words, value]);
        }

        // se inserta el valor en la tupla de tipologias
        this.setWordsTipology(value)

        // Clear the input value
        this.currentWord.set('');
    }

      selected(event: MatAutocompleteSelectedEvent): void {
        let selectedValue = event.option.viewValue
        this.words.update(words => [...words, selectedValue]);
        this.currentWord.set('');
        event.option.deselect();

        // se inserta el valor en la tupla de tipologias
        this.setWordsTipology(selectedValue)

    }


    remove(word: string): void {
        this.words.update(words => {
            const index = words.indexOf(word);
            if (index < 0) {
                return words;
            }

            words.splice(index, 1);
            this.announcer.announce(`Removed ${word}`);
            return [...words];
        });

        // remove del arreglo de tipoligas


        this.WordsTuple.update(words => {
            const index = words.findIndex( w => w.descripcion === word);
            if (index < 0) {
                return words;
            }

            words.splice(index, 1);
            return [...words];
        });
  }


  crearRegistro(){
        // Construir string de palabras clave en formato requerido
        const palabrasClaveToInsert = this._registrosService.buildPalabrasClaveString(this.WordsTuple());
        this.carreaModel.palabraClave = palabrasClaveToInsert;
        this.carreaModel.codigoArea = this.carreaModel.codigoArea || this.carreaModel.codigo || '';

        // Enviar a insertar
        this._registrosService.insertarRegistro(this.carreaModel)
        .then(() => {
            let params = {inicio:0, max:20}
            this._dialogRef?.close()
        })

    }

    Actualizar(){
        const codigo = this.carreaModel?.codigo;
        const message = `¿Desea actualizar el registro ${codigo}?`;

        this._apiService.open_confirm_dialog(message).subscribe((confirmado) => {
            if (!confirmado) { return; }

            // Construir string de palabras clave
            const palabrasClaveToInsert = this._registrosService.buildPalabrasClaveString(this.WordsTuple());
            this.carreaModel.palabraClave = palabrasClaveToInsert;
            this.carreaModel.codigoArea = this.carreaModel.codigoArea || this.carreaModel.codigo || '';

            this._registrosService.actualizarRegistro(this.carreaModel)
            .then((response: any) => {
                this._apiService.showSuccessMessage(response.message ?? `Registro ${codigo} actualizado correctamente`)
                this._dialogRef?.close()
            })
        })

    }


    /**
     * Esta funcion sirve para armar el arreglo en tupla de tipologias que se usara para enviar a guardar o actualizar
     * @param word  palabra seleccionada del chip
     */
    private setWordsTipology(word: string) {
        const descripcion = (word || '').trim();
        if (!descripcion) {
            return;
        }

        // se omiten valores

        // se busca la palabra en la lista de palabras clave
        let tipology = this.allWordsTipology.filter(w => w.descripcion === descripcion)[0]

        if (tipology) {
            this.WordsTuple.update(words => [...words, tipology]) // se inserta el objeto en la tupla
        } else {
            this.WordsTuple.update(words => [...words,  { tipologiaId: 0, descripcion }]) // se insera uno con valor 0
        }

    }

    /**
     * Hidrata chips y tuplas desde carreaModel.palabraClave
     * Formato de contiene carreaModel.palabraClave: (id,descripcion)-(id,descripcion)
     */
    private WordsFromModel(): void {
        const raw = (this.carreaModel?.palabraClave || '').trim();
        if (!raw) { return; }

        const tuples: Tipologia[] = raw
            .split('-')
            .map(p => p.trim())
            .filter(Boolean)
            .map(p => {
                const m = p.match(/^\((\d+),(.*)\)$/);
                const tipologiaId = m ? Number(m[1]) : 0;
                const descripcion = m ? m[2] : p;
                return { tipologiaId, descripcion } as Tipologia;
            });

        const validTuples = tuples.filter(t => (t.descripcion || '').toString().trim() !== '');

        this.WordsTuple.set(validTuples);
        this.words.set(validTuples.map(t => t.descripcion));
    }

    onSelectCiclo(c: Tipologia): void {
        this.permitirActualizacionCodigo = true;
        this.carreaModel.ciclo = c;
        this.cargarTipologiasCarrera();
        this.getModalidad();
    }

    onAreaChange(value: Tipologia | null): void {
        this.permitirActualizacionCodigo = true;
        this.selectedArea = value;
        this.carreaModel.area = value?.descripcion || '';
        this.actualizarCodigoArea();
        if (this.esCicloDiversificado()) {
            this.cargarSubareas(true);
        } else {
            this.resetSubareas();
        }
    }

    onAreaSelected(event: MatAutocompleteSelectedEvent): void {
        const area = event.option.value as Tipologia | null;

        this.areaSearchTerm = area?.descripcion || '';
        this.onAreaChange(area);
    }

    onAreaInput(term: Tipologia | string): void {
        const texto = typeof term === 'string' ? term : (term?.descripcion ?? '');

        this.areaSearchTerm = texto;
        this.filteredAreasCarrera = this.filterTipologias(this.areasCarrera, texto);

        if (!texto.trim()) {
            this.onAreaChange(null);
        }
    }

    onSubareaChange(value: Tipologia | null): void {
        this.permitirActualizacionCodigo = true;
        this.selectedSubarea = value;
        this.carreaModel.subarea = value?.descripcion || '';
        this.subareaSearchTerm = value?.descripcion || '';
        this.actualizarCodigoArea();
    }

    onSubareaSelected(event: MatAutocompleteSelectedEvent): void {
        const subarea = event.option.value as Tipologia | null;

        this.subareaSearchTerm = subarea?.descripcion || '';
        this.onSubareaChange(subarea);
    }

    onSubareaInput(term: Tipologia | string): void {
        const texto = typeof term === 'string' ? term : (term?.descripcion ?? '');

        this.subareaSearchTerm = texto;
        this.filteredSubareasCarrera = this.filterTipologias(this.subareasCarrera, texto);

        if (!texto.trim()) {
            this.onSubareaChange(null);
        }
    }

    onCarreraChange(value: Tipologia | null): void {
        this.selectedCarrera = value;
        this.carreaModel.carrera = value?.descripcion || '';
    }

    onCarreraSelected(event: MatAutocompleteSelectedEvent): void {
        const carrera = event.option.value as Tipologia | null;

        this.carreraSearchTerm = carrera?.descripcion || '';
        this.onCarreraChange(carrera);
    }

    onCarreraInput(term: Tipologia | string): void {
        const texto = typeof term === 'string' ? term : (term?.descripcion ?? '');

        this.carreraSearchTerm = texto;
        this.filteredCarreras = this.filterTipologias(this.carreras, texto);

        if (!texto.trim()) {
            this.onCarreraChange(null);
        }
    }

    onOrientacionOcupacionalChange(value: Tipologia | null): void {
        this.permitirActualizacionCodigo = true;
        this.selectedOrientacionOcupacional = value;
        this.carreaModel.orientacionOcupacional = value?.descripcion || '';
        this.actualizarCodigoArea();
    }

    onOrientacionOcupacionalSelected(event: MatAutocompleteSelectedEvent): void {
        const orientacionOcupacional = event.option.value as Tipologia | null;

        this.orientacionOcupacionalSearchTerm = orientacionOcupacional?.descripcion || '';
        this.onOrientacionOcupacionalChange(orientacionOcupacional);
    }

    onOrientacionOcupacionalInput(term: Tipologia | string): void {
        const texto = typeof term === 'string' ? term : (term?.descripcion ?? '');

        this.orientacionOcupacionalSearchTerm = texto;
        this.filteredOrientacionesOcupacionales =
            this.filterTipologias(this.orientacionesOcupacionales, texto);

        if (!texto.trim()) {
            this.onOrientacionOcupacionalChange(null);
        }
    }

    getModalidad(): void {
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_TIPO_MODALIDAD)
            .then((response: Tipologia) => {
                this.modalidad = response.tipologias || [];

                const valorActual = (this.carreaModel.modalidad || '').toString().trim().toLowerCase();
                const match = this.modalidad.find(
                    m => (m.descripcion || '').trim().toLowerCase() === valorActual
                );
                const first = this.modalidad[0]?.descripcion;
                if (this.esNuevoRegistro && !valorActual) {
                    this.carreaModel.modalidad = '';
                    return;
                }
                this.carreaModel.modalidad = match?.descripcion || first || '';

            });
    }

    getTipoProfesional(): void {
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_TIPO_PROFESIONAL)
            .then((response: Tipologia) => {
                this.tipoProfesional = response.tipologias || [];

                const valorActual = (this.carreaModel.profesional || '').toString().trim().toLowerCase();
                const match = this.tipoProfesional.find(
                    p => (p.descripcion || '').trim().toLowerCase() === valorActual
                );
                const first = this.tipoProfesional[0]?.descripcion;
                if (this.esNuevoRegistro && !valorActual) {
                    this.carreaModel.profesional = '';
                    return;
                }
                this.carreaModel.profesional = match?.descripcion || first || '';

            });
    }

    private cargarTipologiasCarrera(): void {
        this.tipologiasCargadas = { area: false, orientacionOcupacional: false, subarea: false };
        const esDiversificado = this.esCicloDiversificado();

        // Área
        this._registrosService.getTipologias(
            esDiversificado
                ? environment.TIPOLOGIA_ID_AREA_CARRERA_DIVERSIFICADO
                : environment.TIPOLOGIA_ID_AREA_CARRERA_BASICO
        )
            .then((response: Tipologia) => {
                this.areasCarrera = response.tipologias || [];
                const mappedArea = this.mapDescripcionADescripcion(this.carreaModel.area, this.areasCarrera);
                this.carreaModel.area = mappedArea;
                this.selectedArea = this.areasCarrera.find(
                    t => (t.descripcion || '').trim().toLowerCase() === (mappedArea || '').toString().trim().toLowerCase()
                ) || null;
                this.filteredAreasCarrera = [...this.areasCarrera];
                this.areaSearchTerm = this.selectedArea?.descripcion || mappedArea || '';
                this.tipologiasCargadas.area = true;
                this.actualizarCodigoArea();

                if (esDiversificado) {
                    this.cargarSubareas(true);
                } else {
                    this.resetSubareas();
                }
            });

        if (esDiversificado) {
            this.cargarCarreras();
        } else {
            this.resetCarreras();
        }

        // Orientación (solo básico)
        if (!esDiversificado) {
            this._registrosService.getTipologias(environment.TIPOLOGIA_ID_ORIENTACION_BASICO)
                .then((response: Tipologia) => {
                    this.orientacionesCarrera = response.tipologias || [];
                    const mapped = this.mapDescripcionADescripcion(this.carreaModel.orientacion, this.orientacionesCarrera);
                    this.carreaModel.orientacion = mapped;

                    this.selectedOrientacion = this.orientacionesCarrera.find(
                        t => (t.descripcion || '').trim().toLowerCase() === (mapped || '').toString().trim().toLowerCase()
                    ) || (this.esNuevoRegistro && !mapped ? null : this.orientacionesCarrera[0] || null);
                    this.filteredOrientacionesCarrera = [...this.orientacionesCarrera];
                    this.orientacionSearchTerm = this.selectedOrientacion?.descripcion || mapped || '';

                    this.cargarOrientacionesOcupacionalesPorOrientacion(this.selectedOrientacion?.tipologiaId);
                });
        } else {
            this.orientacionesCarrera = [];
            this.carreaModel.orientacion = '';
            this.selectedOrientacion = null;
            this.filteredOrientacionesCarrera = [];
            this.orientacionSearchTerm = '';
            this.cargarOrientacionesOcupacionalesPorOrientacion(null);
        }
    }

    esCicloDiversificado(): boolean {
        const descripcion = this.carreaModel?.ciclo?.descripcion || '';
        const id = this.carreaModel?.ciclo?.tipologiaId || 0;
        const matchDescripcion = descripcion.toLowerCase().includes('diversificado');
        return matchDescripcion || id === environment.TIPOLOGIA_ID_CICLO_DIVERSIFICADO;
    }

    private mapDescripcionADescripcion(valor: string, lista: Tipologia[]): string {
        const valorActual = (valor || '').toString().trim().toLowerCase();
        if (this.esNuevoRegistro && !valorActual) {
            return '';
        }
        const match = lista.find(
            t => (t.descripcion || '').trim().toLowerCase() === valorActual
        );
        const first = lista[0]?.descripcion;
        return match?.descripcion || first || '';
    }

    private actualizarCodigoArea(): void {
        if (!this.permitirActualizacionCodigo) { return; }

        const diversificado = this.esCicloDiversificado();

        const cicloValor2 = (this.carreaModel?.ciclo?.valor2 || '').toString().trim();

        const areaValor1 = (this.selectedArea?.valor1 || '').toString().trim();

        const orientacionOcupacionalValor2 = (this.selectedOrientacionOcupacional?.valor2 || '').toString().trim();
        const subareaValor2 = (this.selectedSubarea?.valor2 || '').toString().trim();
        const valorExtra = diversificado ? subareaValor2 : orientacionOcupacionalValor2;

        const concatenado = [
            cicloValor2,
            areaValor1,
            valorExtra
        ]
            .filter(Boolean)
            .join('');

        this.carreaModel.codigo = concatenado;
    }

    private cargarSubareas(esDiversificado: boolean): void {
        this.tipologiasCargadas.subarea = false;

        if (!esDiversificado) {
            this.resetSubareas();
            return;
        }

        const tipologiaId = this.selectedArea?.tipologiaId || 0;

        if (!tipologiaId) {
            this.resetSubareas();
            return;
        }

        this._registrosService.getTipologias(tipologiaId)
            .then((response: Tipologia) => {
                this.subareasCarrera = response.tipologias || [];
                const mapped = this.mapDescripcionADescripcion(this.carreaModel.subarea, this.subareasCarrera);
                this.carreaModel.subarea = mapped;
                this.selectedSubarea = this.subareasCarrera.find(
                    t => (t.descripcion || '').trim().toLowerCase() === (mapped || '').toString().trim().toLowerCase()
                ) || null;
                this.filteredSubareasCarrera = [...this.subareasCarrera];
                this.subareaSearchTerm = this.selectedSubarea?.descripcion || mapped || '';
                this.tipologiasCargadas.subarea = true;
                this.actualizarCodigoArea();
            });
    }

    private resetSubareas(): void {
        this.subareasCarrera = [];
        this.filteredSubareasCarrera = [];
        this.selectedSubarea = null;
        this.subareaSearchTerm = '';
        this.carreaModel.subarea = '';
        this.tipologiasCargadas.subarea = false;
        this.actualizarCodigoArea();
    }

    private cargarCarreras(): void {
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_CARRERA_DIVERSIFICADO)
            .then((response: Tipologia) => {
                this.carreras = response.tipologias || [];
                const valorActual = this.normalizeCarrera(this.carreaModel.carrera);
                const match = this.carreras.find(
                    t => this.normalizeCarrera(t.descripcion) === valorActual
                ) || null;
                this.selectedCarrera = match;
                this.carreaModel.carrera = match?.descripcion || '';
                this.filteredCarreras = [...this.carreras];
                this.carreraSearchTerm = this.selectedCarrera?.descripcion || '';
            });
    }

    private resetCarreras(): void {
        this.carreras = [];
        this.filteredCarreras = [];
        this.selectedCarrera = null;
        this.carreraSearchTerm = '';
        this.carreaModel.carrera = '';
    }

    private cargarOrientacionesOcupacionalesPorOrientacion(tipologiaId?: number | null): void {
        this.tipologiasCargadas.orientacionOcupacional = false;

        if (!tipologiaId) {
            this.orientacionesOcupacionales = [];
            this.filteredOrientacionesOcupacionales = [];
            this.selectedOrientacionOcupacional = null;
            this.orientacionOcupacionalSearchTerm = '';
            this.actualizarCodigoArea();
            return;
        }

        this._registrosService.getTipologias(tipologiaId)
            .then((response: Tipologia) => {
                this.orientacionesOcupacionales = response.tipologias || [];
                this.filteredOrientacionesOcupacionales = [...this.orientacionesOcupacionales];
                const mapped = this.mapDescripcionADescripcion(
                    this.carreaModel.orientacionOcupacional,
                    this.orientacionesOcupacionales
                );
                this.carreaModel.orientacionOcupacional = mapped;
                this.selectedOrientacionOcupacional = this.orientacionesOcupacionales.find(
                    t => (t.descripcion || '').trim().toLowerCase() === (mapped || '').toString().trim().toLowerCase()
                ) || null;
                this.orientacionOcupacionalSearchTerm = this.selectedOrientacionOcupacional?.descripcion || mapped || '';
                this.tipologiasCargadas.orientacionOcupacional = true;
                this.actualizarCodigoArea();
            });
    }

    onOrientacionChange(orientacionSeleccionada: Tipologia | null): void {
        this.permitirActualizacionCodigo = true;
        this.selectedOrientacion = orientacionSeleccionada;
        this.carreaModel.orientacion = orientacionSeleccionada?.descripcion || '';
        this.cargarOrientacionesOcupacionalesPorOrientacion(orientacionSeleccionada?.tipologiaId);
    }

    onOrientacionSelected(event: MatAutocompleteSelectedEvent): void {
        const orientacion = event.option.value as Tipologia | null;

        this.orientacionSearchTerm = orientacion?.descripcion || '';
        this.onOrientacionChange(orientacion);
    }

    onOrientacionInput(term: Tipologia | string): void {
        const texto = typeof term === 'string' ? term : (term?.descripcion ?? '');

        this.orientacionSearchTerm = texto;
        this.filteredOrientacionesCarrera =
            this.filterTipologias(this.orientacionesCarrera, texto);

        if (!texto.trim()) {
            this.onOrientacionChange(null);
        }
    }

    displayTipologia(value: Tipologia | string): string {
        if (typeof value === 'string') {
            return value;
        }

        return value?.descripcion || '';
    }

    /**
     * Clona el modelo recibido para evitar que los cambios en el formulario
     */
    private clonarCarrera(origen: CarreraModel): CarreraModel {
        return JSON.parse(JSON.stringify(origen)) as CarreraModel;
    }

    private normalize(value: unknown): string {
        return (value ?? '').toString().trim().toLowerCase();
    }

    // Normalización específica para carreras: ignora el correlativo inicial "[123] ".
    private normalizeCarrera(value: unknown): string {
        return this.normalize(value).replace(/^\[\d+\]\s*/, '').trim();
    }

    private filterTipologias(source: Tipologia[], term: unknown): Tipologia[] {
        const q = this.normalize(term);
        if (!q) return [...source];

        return source.filter(item =>
            this.normalize(item.descripcion).includes(q)
        );
    }


}
